import { IdGrowthFundOfferId } from "../../constants/IdGrowthFundOfferId";
import { IdOutskirtBuildings } from "../../constants/IdOutskirtBuildings";
import { EventType } from "../balancing/types/BalancingCore";
import { actionDiscountEventActionButtonClick } from "../discount-event/actionDiscountEvent";
import { IdIcon } from "../generic/icon/IdIcon";
import { actionPlayerSettingsViewBlog } from "../info/player-settings/actionPlayerSettingsInfo";
import { actionModalOpen } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
import { actionShopOpenOffer } from "../shop/actionShop";
import { actionActionButtonFocusBuilding } from "./actionHudActionButton";
import { IdActionButtonEntries } from "./IdActionButtonEntries";
import { IdActionButtonPriority } from "./IdActionButtonPriority";
// TODO add missing buttons
export var mapActionButton = new Map([
    [
        IdActionButtonEntries.WebExclusivePackage,
        {
            action: actionModalOpen(IdModal.WebExclusiveReward),
            icon: IdIcon.WebOnlyGiftIcn,
            id: IdActionButtonEntries.WebExclusivePackage,
            priority: IdActionButtonPriority.WebExclusivePackage,
        },
    ],
    [
        IdActionButtonEntries.PIBirthdayGift,
        {
            action: actionModalOpen(IdModal.PendingInventory),
            icon: IdIcon.GiftIcn,
            id: IdActionButtonEntries.PIBirthdayGift,
            priority: IdActionButtonPriority.PIBirthdayGift,
        },
    ],
    [
        IdActionButtonEntries.PISkyGift,
        {
            action: actionModalOpen(IdModal.PendingInventory),
            icon: IdIcon.GiftIcn,
            id: IdActionButtonEntries.PISkyGift,
            priority: IdActionButtonPriority.PISkyGift,
        },
    ],
    [
        IdActionButtonEntries.PIWelcomeBack,
        {
            action: actionModalOpen(IdModal.PendingInventory),
            icon: IdIcon.GiftIcn,
            id: IdActionButtonEntries.PIWelcomeBack,
            priority: IdActionButtonPriority.PIWelcomeBack,
        },
    ],
    [
        IdActionButtonEntries.GoldGrowthPackageAvailable,
        {
            action: actionShopOpenOffer(IdGrowthFundOfferId.Gold),
            icon: IdIcon.GoldCoinsDecoIcn,
            id: IdActionButtonEntries.GoldGrowthPackageAvailable,
            priority: IdActionButtonPriority.GoldGrowthPackageAvailable,
        },
    ],
    [
        IdActionButtonEntries.PIPlayerLeagueRanking,
        {
            action: actionModalOpen(IdModal.PendingInventory),
            icon: IdIcon.Tournament_rewards_Inc,
            id: IdActionButtonEntries.PIPlayerLeagueRanking,
            priority: IdActionButtonPriority.PIPlayerLeagueRanking,
        },
    ],
    [
        IdActionButtonEntries.PIPlayerLeagueReward,
        {
            action: actionModalOpen(IdModal.PendingInventory),
            icon: IdIcon.Tournament_rewards_Inc,
            id: IdActionButtonEntries.PIPlayerLeagueReward,
            priority: IdActionButtonPriority.PIPlayerLeagueReward,
        },
    ],
    [
        IdActionButtonEntries.PICoopLeagueReward,
        {
            action: actionModalOpen(IdModal.PendingInventory),
            icon: IdIcon.Tournament_rewards_Inc,
            id: IdActionButtonEntries.PICoopLeagueReward,
            priority: IdActionButtonPriority.PICoopLeagueReward,
        },
    ],
    [
        IdActionButtonEntries.PICoopLeagueRanking,
        {
            action: actionModalOpen(IdModal.PendingInventory),
            icon: IdIcon.Tournament_rewards_Inc,
            id: IdActionButtonEntries.PICoopLeagueRanking,
            priority: IdActionButtonPriority.PICoopLeagueRanking,
        },
    ],
    [
        IdActionButtonEntries.PICollectLeagueReward,
        {
            action: actionModalOpen(IdModal.PendingInventory),
            icon: IdIcon.Tournament_rewards_Inc,
            id: IdActionButtonEntries.PICollectLeagueReward,
            priority: IdActionButtonPriority.PICollectLeagueReward,
        },
    ],
    [
        IdActionButtonEntries.PICollectLeagueRanking,
        {
            action: actionModalOpen(IdModal.PendingInventory),
            icon: IdIcon.Tournament_rewards_Inc,
            id: IdActionButtonEntries.PICollectLeagueRanking,
            priority: IdActionButtonPriority.PICollectLeagueRanking,
        },
    ],
    [
        IdActionButtonEntries.PromoteLeagueLevel,
        {
            action: actionModalOpen(IdModal.PromoteDemote),
            icon: IdIcon.LeaguePromotedIcn,
            id: IdActionButtonEntries.PromoteLeagueLevel,
            priority: IdActionButtonPriority.PromoteLeagueLevel,
        },
    ],
    [
        IdActionButtonEntries.DemoteLeagueLevel,
        {
            action: actionModalOpen(IdModal.PromoteDemote),
            icon: IdIcon.LeagueDemotedIcn,
            id: IdActionButtonEntries.DemoteLeagueLevel,
            priority: IdActionButtonPriority.DemoteLeagueLevel,
        },
    ],
    [
        IdActionButtonEntries.ExpansionDiscount,
        {
            action: actionDiscountEventActionButtonClick(EventType.ExpansionDiscount),
            icon: IdIcon.ExpansionSaleIcn,
            id: IdActionButtonEntries.ExpansionDiscount,
            priority: IdActionButtonPriority.ExpansionDiscount,
        },
    ],
    [
        IdActionButtonEntries.ExternalBarnDiscount,
        {
            action: actionDiscountEventActionButtonClick(EventType.OutskirtDiscount),
            icon: IdIcon.PrimeSaleIcn,
            id: IdActionButtonEntries.ExternalBarnDiscount,
            priority: IdActionButtonPriority.ExternalBarnDiscount,
        },
    ],
    [
        IdActionButtonEntries.Blog,
        {
            action: actionPlayerSettingsViewBlog(),
            icon: IdIcon.BlogIcn,
            id: IdActionButtonEntries.Blog,
            priority: IdActionButtonPriority.Blog,
        },
    ],
    [
        IdActionButtonEntries.PISystem,
        {
            action: actionModalOpen(IdModal.PendingInventory),
            icon: IdIcon.GiftIcn,
            id: IdActionButtonEntries.PISystem,
            priority: IdActionButtonPriority.PISystem,
        },
    ],
    [
        IdActionButtonEntries.PICafeGift,
        {
            action: actionModalOpen(IdModal.PendingInventory),
            icon: IdIcon.GiftIcn,
            id: IdActionButtonEntries.PICafeGift,
            priority: IdActionButtonPriority.PICafeGift,
        },
    ],
    // PISony prio 18  NEVER IMPLEMENT!!!
    [
        IdActionButtonEntries.CoopLevelUp,
        {
            action: actionModalOpen(IdModal.CooperativeLevelUp),
            icon: IdIcon.CoopUpdatesIcn,
            id: IdActionButtonEntries.CoopLevelUp,
            priority: IdActionButtonPriority.CoopLevelUp,
        },
    ],
    // Adventures prio 20
    [
        IdActionButtonEntries.PlayerLeagueStart,
        {
            action: actionActionButtonFocusBuilding(IdOutskirtBuildings.TournamentTent),
            icon: IdIcon.GoldCupIcn,
            id: IdActionButtonEntries.PlayerLeagueStart,
            priority: IdActionButtonPriority.PlayerLeagueStart,
        },
    ],
    [
        IdActionButtonEntries.CoopLeagueStart,
        {
            action: actionActionButtonFocusBuilding(IdOutskirtBuildings.TournamentTent),
            icon: IdIcon.GoldCupIcn,
            id: IdActionButtonEntries.CoopLeagueStart,
            priority: IdActionButtonPriority.CoopLeagueStart,
        },
    ],
    [
        IdActionButtonEntries.ThemedEvents,
        {
            action: actionActionButtonFocusBuilding(IdOutskirtBuildings.ThemedEvent),
            icon: IdIcon.Empty,
            id: IdActionButtonEntries.ThemedEvents,
            priority: IdActionButtonPriority.ThemedEvents,
        },
    ],
    // SaveAccount prio 24
    [
        IdActionButtonEntries.WaterTower,
        {
            action: actionActionButtonFocusBuilding(IdOutskirtBuildings.Watertower),
            icon: IdIcon.WaterIcn,
            id: IdActionButtonEntries.WaterTower,
            priority: IdActionButtonPriority.WaterTower,
        },
    ],
    [
        IdActionButtonEntries.Dog,
        {
            action: actionActionButtonFocusBuilding(IdOutskirtBuildings.Doghouse),
            icon: IdIcon.DogTabIcn,
            id: IdActionButtonEntries.Dog,
            priority: IdActionButtonPriority.Dog,
        },
    ],
    [
        IdActionButtonEntries.ProjectFinished,
        {
            action: actionModalOpen(IdModal.CoopProjectCompleted),
            icon: IdIcon.CoopUpdatesIcn,
            id: IdActionButtonEntries.ProjectFinished,
            priority: IdActionButtonPriority.ProjectFinished,
        },
    ],
    // cafe prio 28
    [
        IdActionButtonEntries.PISatisfaction,
        {
            action: actionModalOpen(IdModal.PendingInventory),
            icon: IdIcon.HappinessPositiveIcn,
            id: IdActionButtonEntries.PISatisfaction,
            priority: IdActionButtonPriority.PISatisfaction,
        },
    ],
    [
        IdActionButtonEntries.PIFriendGift,
        {
            action: actionModalOpen(IdModal.PendingInventory),
            icon: IdIcon.GiftIcn,
            id: IdActionButtonEntries.PIFriendGift,
            priority: IdActionButtonPriority.PIFriendGift,
        },
    ],
    [
        IdActionButtonEntries.PIPurchasePointsReward,
        {
            action: actionModalOpen(IdModal.PendingInventory),
            icon: IdIcon.PointsIcn,
            id: IdActionButtonEntries.PIPurchasePointsReward,
            priority: IdActionButtonPriority.PIPurchasePointsReward,
        },
    ],
    [
        IdActionButtonEntries.CoopInvitation,
        {
            action: actionModalOpen(IdModal.CoopInvitation),
            icon: IdIcon.CooperativeIcn,
            id: IdActionButtonEntries.CoopInvitation,
            priority: IdActionButtonPriority.CoopInvitation,
        },
    ],
    [
        IdActionButtonEntries.Trader,
        {
            action: actionModalOpen(IdModal.PendingInventory),
            icon: IdIcon.GiftIcn,
            id: IdActionButtonEntries.Trader,
            priority: IdActionButtonPriority.Trader,
        },
    ],
    // QuestThree prio 34
    // no prio set in mobile
    [
        IdActionButtonEntries.PremiumHouseDiscount,
        {
            action: actionDiscountEventActionButtonClick(EventType.FancyHouseDiscount),
            icon: IdIcon.PrimeSaleIcn,
            id: IdActionButtonEntries.PremiumHouseDiscount,
            priority: IdActionButtonPriority.PremiumHouseDiscount,
        },
    ],
    [
        IdActionButtonEntries.PremiumAcreDiscount,
        {
            action: actionDiscountEventActionButtonClick(EventType.FertileAcreDiscount),
            icon: IdIcon.PrimeSaleIcn,
            id: IdActionButtonEntries.PremiumAcreDiscount,
            priority: IdActionButtonPriority.PremiumAcreDiscount,
        },
    ],
    [
        IdActionButtonEntries.PrimeTime,
        {
            action: actionDiscountEventActionButtonClick(EventType.PrimeTime),
            icon: IdIcon.PrimeSaleIcn,
            id: IdActionButtonEntries.PrimeTime,
            priority: IdActionButtonPriority.PrimeTime,
        },
    ],
    // web only
    [
        IdActionButtonEntries.PromoteMobile,
        {
            action: actionModalOpen(IdModal.PromoteMobile),
            icon: IdIcon.RitaIcn,
            id: IdActionButtonEntries.PromoteMobile,
            priority: IdActionButtonPriority.PromoteMobile,
        },
    ],
    [
        IdActionButtonEntries.PI_AnniversaryGift,
        {
            action: actionModalOpen(IdModal.PendingInventory),
            icon: IdIcon.GiftIcn,
            id: IdActionButtonEntries.PI_AnniversaryGift,
            priority: IdActionButtonPriority.PI_AnniversaryGift,
        },
    ],
]);



//////////////////
// WEBPACK FOOTER
// ./src/features/hud-action-button/mapActionButton.ts
// module id = 586
// module chunks = 3